import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieConsentBannerComponent } from './shared/components/cookie-consent-banner/cookie-consent-banner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CookieConsentBannerComponent],
  template: `
    <router-outlet></router-outlet>
    <app-cookie-consent-banner></app-cookie-consent-banner>
  `
})
export class AppComponent {
  title = 'exam-pal-ui';
}
